import React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import theme from './../theme';
//components
import Contour from '../components/common/Contour';
import CustomizedTimeline from './traceability-page/CustomizedTimeline';
//icons
import ArrowBack from '@material-ui/icons/ArrowBack';
//Redux
import { useSelector } from 'react-redux';
//Selectors
import { selectTraceability } from './traceability-page/selectors';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  arrowBack: {
    color: '#024266',
    marginTop: '20px',
    marginLeft: '40px',
  },
}));
export default function TransfersPage(props) {
  const classes = useStyles();
  const history = useHistory();
  const traceability = useSelector(selectTraceability);
  const { t } = useTranslation();

  const back = (e) => {
    e.stopPropagation();
    history.goBack();
  };

  return (
    <>
      <Contour title={t('transfers')} color={theme.palette.secondary.light} />
      <ArrowBack
        fontSize="large"
        className={classes.arrowBack}
        onClick={back}
      />
      <div style={{ margin: '40px' }}>
        <CustomizedTimeline transfers={traceability} />
      </div>
    </>
  );
}
